<template>
  <div class="homepage--template">
    <div class="home-handle-overflow">
      <!-- <div
        v-show="isWindowWidthMobile"
        class="db dn-ns relative w-100 container-fluid-xs ph4 ph0-ns pv3 pv5-ns bg-beige z-content"
      >
        <h1 class="absolute mv0 tc h1 w1 transparent" style="color: transparent">
          Outside Lands
        </h1>
        <div class="db relative center w-100 mw7">
          <simple-svg
            class=""
            :filepath="'/assets/images/logos/ol21-logo-lockup-outline.svg'"
            :id="'ol20-logo-lockup-red'"
          >
          </simple-svg>
        </div>
      </div> -->
      <div
        v-show="
          !!page.landing_section &&
            !isWindowWidthMobile &&
            page.landing_section.is_bg_video_visible
        "
        class="dn db-ns relative w-100 z-content bg-beige aspect-ratio aspect-ratio--16x9 bg-vid-image"
        v-lazy:background="page.landing_section.video_bg_image"
      >
        <h1
          class="absolute mv0 tc h1 w1 transparent"
          style="color: transparent"
        >
          Outside Lands
        </h1>
        <div class="vimeo-wrapper absolute aspect-ratio aspect-ratio--16x9 bg">
          <iframe
            class="aspect-ratio--object cover"
            :src="
              'https://player.vimeo.com/video/' +
                page.landing_section.background_video_vimeo_id +
                '?background=1&autoplay=1&loop=1&byline=0&title=0'
            "
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        </div>
        <div class="db absolute abs-vert-center left-0 right-0 center mw7">
          <simple-svg
            class=""
            :filepath="'/assets/images/logos/ol21-logo-lockup-outline.svg'"
            :id="'ol20-logo-lockup-yellow'"
          >
          </simple-svg>
        </div>
      </div>
      <div
        class="db relative w-100 h-auto pv4 pt5-ns pb6-ns z-content bg-beige"
      >
        <div class="relative container-fluid">
          <section
            v-show="isWindowWidthMobile"
            class="relative center mw8-4 dn flex-ns flex-column flex-row-ns items-center pb4 pb5-ns"
          >
            <router-link
              class="db relative center mw6 mt4-ns ph4 btn-primary has-red-bg"
              :to="page.landing_section.cta_button.link"
              v-if="page.landing_section.cta_button.is_published"
            >
              <span class="text">
                {{ page.landing_section.cta_button.copy }}
              </span>
            </router-link>
            <router-link
              class="db relative center mw6 mt5 mt4-ns ph4 btn-primary has-teal-bg"
              :to="page.landing_section.cta_button_2.link"
              v-if="page.landing_section.cta_button_2.is_published"
            >
              <span class="text">
                {{ page.landing_section.cta_button_2.copy }}
              </span>
            </router-link>
          </section>
          <!-- <simple-svg
                          class="logo-main"
                          filepath="/assets/images/svg/ol21-lockup-header-scroll-new-dates.svg"
                        ></simple-svg>
          <h2 class="f40px is-blenny is-navy center-md">IMPORTANT FESTIVAL INFORMATION</h2> -->
          <div class="relative z-content bg-beige pv5">
            <!-- <div class="row">
              
              <a v-for="(featured, index) in featuredContentTop" class="col-xs-12 col-sm-4 mb3 hft" 
                :href="featured.link" target="_blank" 
                :title="featured.title" 
                :key="'featured-item-' + index">
                <img class="center w100" :src="featured.image" :title="featured.title" />
                <div class="relative w-100 mw8-4 center mb3 bg-navy bullseye-background">
                  <h4 class="f20px is-tablet-bold mt4 mb3 home-news-link w-100-ns w-100 pl4-ns pl5 pr4 pr4-ns pt3 pt4 pt4-m pt4-l mt-4">{{ featured.title }}</h4>
                  <div class="f4 mv3 lh-copy is-beige w-100-ns w-100 pl5 pl4-ns pr4 pr4-ns pb4 pb4-m pb4-l mt-4" v-html="featured.text"></div>
                </div>
              </a>
            </div> -->
            <img src="/uploads/thankyou-2x1.png" alt="thank you for coming" />
          </div>
          <!-- <section class="db relative center mw8-4 mb4 mv3-ns">
            <div class="" v-if="page.admat_section.is_link_out">
              <a
                :href="page.admat_section.link"
                v-if="page.admat_section.header_text && page.admat_section.link"
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                v-html="marked(page.admat_section.header_text)"
                target="_blank"
              ></a>
              <a
                href="https://outsidelands.shop.musictoday.com/store/"
                v-else
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                target="_blank"
                >{{ page.admat_section.header_text }}</a
              >
            </div>
            <div class="" v-else>
              <router-link
                :to="page.admat_section.link"
                v-if="page.admat_section.header_text && page.admat_section.link"
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                v-html="marked(page.admat_section.header_text)"
              ></router-link>
              <router-link
                to="/tickets"
                v-else
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                >{{ page.admat_section.header_text }}</router-link
              >
            </div>
            <a class="db relative ph4 ph5-ns pv4 pv5-ns pointer bg-navy bg-bows-blue"> </a>
            <a
              class="db relative pt0 pt4-ns pb4 pointer admat-hover"
              href="/lineup/"
              title="Outside Lands 2021 Lineup"
            >
              <img
                v-show="isWindowWidthMobile"
                class="db dn-ns relative z-content"
                v-lazy="page.admat_section.mobile_image"
              />
              <img
                v-show="!isWindowWidthMobile"
                class="dn db-ns relative z-content admat-regular"
                v-lazy="page.admat_section.desktop_image"
              />
              <img
                v-show="!isWindowWidthMobile"
                v-if="page.admat_section.desktop_black_image"
                class="dn db-ns relative z-content admat-black"
                :src="page.admat_section.desktop_black_image"
              />
              <img
                v-show="isWindowWidthMobile"
                v-if="page.admat_section.mobile_black_image"
                class="dn db-ns relative z-content admat-black"
                :src="page.admat_section.mobile_black_image"
              />
            </a>
          </section> -->
          <section
            :id="page.about_section.slug"
            class="db relative mv4 mv5-ns center mw8-4"
          >
            <div
              class="cms-content"
              v-html="marked(page.about_section.text)"
            ></div>
          </section>
          <!-- <section
            class="db relative center mw8-4 flex flex-column flex-row-ns items-center mt5 pb4 pb5-ns"
          >
            <router-link
              class="db relative center mw6 ph4 btn-primary has-red-bg"
              :to="page.landing_section.cta_button.link"
              v-if="page.landing_section.cta_button.is_published"
            >
              <span class="text">
                {{ page.landing_section.cta_button.copy }}
              </span>
            </router-link>
            <router-link
              class="db relative center mw6 mt4 mt0-ns ph4 btn-primary has-teal-bg"
              :to="page.landing_section.cta_button_2.link"
              v-if="page.landing_section.cta_button_2.is_published"
            >
              <span class="text">
                {{ page.landing_section.cta_button_2.copy }}
              </span>
            </router-link>
          </section> -->
        </div>
      </div>
      <fixedbg :background="page.fixed_bg_section.image">
        <template slot="contents">
          <accolades-static>
            <template slot="fixed-bg-contents">
              <div class="" v-html="page.fixed_bg_section.text"></div>
            </template>
          </accolades-static>
        </template>
      </fixedbg>
      <div class="relative z-content bg-beige pv5">
        <section
          id="featured_content_carousel"
          class="relative center pv4 is-black"
        >
          <div
            class="swiper-button-prev-home outline-0 absolute h-100 z-6"
            slot="button-prev"
          ></div>
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide
              v-for="(featured, index) in featuredContentSlidesFiltered"
              :key="'featured-carousel-item' + index"
            >
              <router-link
                :to="featured.link"
                class="relative slide fl"
                :title="featured.title"
              >
                <div class="db w-100">
                  <div class="db relative center img-main fl z-2">
                    <img :src="featured.image" :alt="featured.title" />
                  </div>
                  <div class="dib relative fl z-2 img-icon">
                    <img
                      class="absolute abs-vert-center"
                      :src="featured.icon_image"
                      :alt="featured.title + ' Icon'"
                    />
                  </div>
                  <div class="dib content-info fl relative z-2">
                    <h3 class="f22px is-tablet-bold mt4 mb3">
                      {{ featured.title }}
                    </h3>
                    <p class="f18px is-tablet-regular">{{ featured.text }}</p>
                  </div>
                </div>
              </router-link>
            </swiper-slide>
            <div
              class="swiper-pagination swiper-pagination-bullets"
              slot="pagination"
            ></div>
          </swiper>
          <div
            class="swiper-button-next-home outline-0 absolute h-100 z-6"
            slot="button-next"
          ></div>
        </section>
      </div>
      <div
        class="relative w-100 pt3-ns pb6 flex flex-column bg-beige z-content container-fluid"
      >
        <div class="relative w-100 mw8-4 center mb3 bg-navy">
          <div class="relative z-4">
            <div class="relative center pv3 ph4 b-bottom--beige-ns">
              <span class="db relative">
                <h2 class="f64px lh-title is-blenny is-beige pl3-ns">NEWS</h2>
                <img
                  class="db dn-ns absolute right-0 bottom-0 nb3 mw-news-icon z--1"
                  src="/assets/images/bg-icons/ol20-flower-icon-red-flat.svg"
                />
                <img
                  class="dn db-ns absolute left-0 right-0 center bottom-0 pr5 nb5 mw-news-icon"
                  src="/assets/images/bg-icons/ol20-flower-icon-red-flat.svg"
                />
              </span>
            </div>
            <div class="relative row middle-sm">
              <div class="dn db-ns col-sm-6 ph4 mb4">
                <div
                  class="w-90-ns pr4-ns pv3 pv4-m pv4-l"
                  v-for="(post, index) in postsHome"
                  :key="'home-news-post-' + index"
                >
                  <router-link class="home-news-link" :to="post.url"
                    ><h4 class="is-beige is-tablet-wide-bold f20px lh-title">
                      {{ post.title
                      }}<span class="dib w1 ml2"
                        ><simple-svg
                          class="right-arrow is-orange news-right-arrow"
                          :filepath="'/uploads/checkout-arrow.svg'"
                        ></simple-svg
                      ></span></h4
                  ></router-link>
                  <span class="db mt3 is-beige is-tablet-regular ttu f15px">{{
                    post.date | formatDate
                  }}</span>
                </div>
                <a class="f15px is-tablet-bold pb4 lh-20px ttu is-tablet-regular is-yellow mb4" 
                  :title="'news'" 
                  :href="'news'" >
                    View More News Posts 
                    <simple-svg class="checkout is-yellow" 
                      :filepath="'/uploads/checkout-arrow.svg'">
                    </simple-svg>
                </a>
              </div>
              <div
                class="col-xs-12 col-sm-6 pv4 ph4 b-top--beige-xs b-bottom--beige-xs"
              >
                <img
                  class="w-100 relative"
                  v-lazy="'/uploads/news-img1.jpg'"
                  alt="News image"
                />
              </div>
              <div class="dn-ns flex flex-column col-xs-12 mv3 ph4">
                <div
                  class="w-90-ns pr4-ns pv3 pv4-m pv4-l"
                  v-for="(post, index) in postsHome"
                  :key="'home-news-post-' + index"
                >
                  <router-link class="home-news-link" :to="post.url"
                    ><h4 class="is-beige is-tablet-wide-bold f20px lh-title">
                      {{ post.title
                      }}<span class="dib w1 ml2"
                        ><simple-svg
                          class="right-arrow is-orange news-right-arrow"
                          :filepath="'/uploads/checkout-arrow.svg'"
                        ></simple-svg
                      ></span></h4
                  ></router-link>
                  <span class="db mt3 is-beige is-tablet-regular ttu f15px">{{
                    post.date | formatDate
                  }}</span>
                </div>
                <a class="f15px is-tablet-bold pb4 lh-20px ttu is-tablet-regular is-yellow" 
                  :title="'news'" 
                  :href="'news'" >
                    View More News Posts 
                    <simple-svg class="checkout is-yellow" 
                      :filepath="'/uploads/checkout-arrow.svg'">
                    </simple-svg>
                </a>
              </div>
              
              <div
                class="dn db-ns absolute left-0 right-0 center w1 h-100 b-vert--beige-ns"
              ></div>
            </div>
          </div>
        </div>
        <!-- <a href="/uploads/OL21_MasterMap_10.12_v3.jpg" alt="map image download">
          <img src="/uploads/OL21_MasterMap_10.12_v3.jpg" class="relative z-content mt4"/>
        </a>   -->
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from "./signup-form.vue";
import AppImage from "./app-image.vue";
//import VidModal from './vid-modal.vue';
import AccoladesSwiper from "./accolades-swiper.vue";
import AccoladesStatic from "./accolades-static.vue";
import Fixedbg from "./fixedbg.vue";
import BgVimeoVideoEmbed from "./bg-vimeo-video-embed.vue";
export default {
  components: {
    AccoladesSwiper,
    AccoladesStatic,
    SignupForm,
    Fixedbg,
    BgVimeoVideoEmbed
    //'cta-footer': () => import('./cta-footer.vue')
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: titleChunk => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk}` : "";
      },
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.page.seo_description
        }
      ]
    };
  },
  data() {
    return {
      newArray: [],
      appIsLoaded: true,
      logoIsLoaded: false,
      isWindowWidthMobile: false,
      windowWidth: null,
      parallax: null,
      rayRotateDeg: 0,
      swiperOptions: {
        speed: 700,
        autoplayDisableOnInteraction: false,
        loop: true,
        initialSlide: 0,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        },
        keyboardControl: true,
        navigation: {
          nextEl: ".swiper-button-next-home",
          prevEl: ".swiper-button-prev-home"
        },
        initialSlide: 0,
        spaceBetween: 0,
        centeredSlides: true,
        slidesPerView: 2.2,
        afterLoad: false,
        breakpoints: {
          540: {
            slidesPerView: 1.3
          },
          840: {
            slidesPerView: 1.8,
            loopAdditionalSlides: 1
          }
        }
      }
    };
  },
  computed: {
    page: function() {
      var pageData = this.$store.getters.filterPagesByName("index.markdown");
      return pageData[0];
    },
    posts: function() {
      var postsData = this.$store.getters.filterDataByCollection("posts");
      return postsData;
    },
    postsHome: function() {
      if (this.posts) {
        let postsArr = [];
        postsArr = this.posts.filter(post => {
          if (post.is_insidelands_post != true) {
            return post;
          }
        });
        postsArr = postsArr.filter((post, index) => {
          return index < 3;
        });
        return postsArr;
      }
    },
    swiper() {
      if (this.$refs.mySwiper) return this.$refs.mySwiper.swiper;
    },
    featuredContentSlidesFiltered: function() {
      const slides = this.page.featured_content_carousel.slides;
      if (!slides) return;
      const slidesFiltered = [...slides].filter(
        slide => slide.is_published === true
      );
      return slidesFiltered;
    },
    featuredContentTop: function() {
      const slides = this.page.featured_top_content.slides;
      if (!slides) return;
      const slidesFiltered = [...slides].filter(
        slide => slide.is_published === true
      );
      return slidesFiltered;
    }
  },
  methods: {
    sizing: function() {
      this.windowWidth = window.innerWidth;
      // this.window.height = window.innerHeight;
      if (this.windowWidth < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
      }
      if (this.swiper) this.swiper.update();
    },
    imageLoc: function(index, name) {
      if (this.$refs["artist" + index + "-" + name]) {
        // console.log(this.$refs['artist'+index+'-'+name][0].parentElement.getBoundingClientRect().height);
        var update = this.windowWidth;
        if (
          this.$refs[
            "artist" + index + "-" + name
          ][0].parentElement.getBoundingClientRect().height > 37
        ) {
          var i;
          var left = 0;
          for (i = 0; i < name; i++) {
            var letterLeft =
              this.$refs["artist" + index + "-" + i][0].getBoundingClientRect()
                .x +
              this.$refs["artist" + index + "-" + i][0].getBoundingClientRect()
                .width;
            if (letterLeft > left) left = letterLeft;
          }
          return "left: " + left + "px;";
        } else {
          return "right: 20px;";
        }
      } else return "right: 20px;";
    }
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true;
    } else {
      this.isWindowWidthMobile = false;
    }
    window.addEventListener("resize", this.sizing);
    window.addEventListener("load", this.sizing);
  },
  mounted() {
    var w = window.innerWidth;
    if (w < 768) {
      setInterval(() => {
        this.rayRotateDeg = this.rayRotateDeg + 0.16;
      }),
        10;
    } else {
      setInterval(() => {
        this.rayRotateDeg = this.rayRotateDeg + 0.06;
      }),
        10;
    }
    /* Hash Anchor Link functionality */
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace("#", "");
        document
          .getElementById(element)
          .scrollIntoView({ block: "end", behavior: "smooth" });
      }, 300);
    }
    this.$nextTick(() => {
      //
    });
    function shuffle(array) {
      var tmp,
        current,
        top = array.length;

      if (top)
        while (--top) {
          current = Math.floor(Math.random() * (top + 1));
          tmp = array[current];
          array[current] = array[top];
          array[top] = tmp;
        }

      return array;
    }

    let picArray = [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23
    ];

    this.newArray = shuffle(picArray);
    console.log(this.newArray[0]);
  },
  destroyed() {
    window.removeEventListener("resize", this.sizing);
    window.removeEventListener("load", this.sizing);
  }
};
</script>
